import React from "react";
import { useNavigate } from "react-router";

function SectionAIDetect() {

  const handleClickAIDetectButton = () => {
    navigate('/ai-detector'); //Navigate to new route
  } //handle button click

  const navigate = useNavigate(); //react router navigate

  return (
    <div className="container" style={{ marginTop: "7rem" }}>
      {/* title section */}
      <div className="justify-content-center text-center">
        {/* We can detect AI written texts */}
        <h1 className="display-6">We can also detect AI written texts</h1>
      </div>

      <div className="row">
        {/* image section */}
        <div className="col-lg-3 col-sm-12 d-none d-lg-block mt-5">
          <img
            src="./images/ai_detection_meter.png"
            alt="AI Humanizer"
            className="img-fluid rounded shadow-sm object-fit-cover"
            style={{ width: "100%" }}
          />

          {/* button AI detector */}
          <div className="text-center mt-5">
            <button
              className="btn btn-secondary px-5 py-2 fs-6 rounded-pill"
              type="button"
              onClick={handleClickAIDetectButton}
              role="link"
            >
              AI Detector
            </button>
          </div>
        </div>

        {/* answer section */}
        <div className="col-lg-9 col-sm-12">
          {/* description section */}
          <p className="lead mt-5 ms-3">
            Our AI detector is designed to analyze text and determine whether it
            was written by a human or generated by artificial intelligence.
            Using advanced natural language processing and machine learning
            algorithms, it evaluates patterns, phrasing, and other linguistic
            cues to identify AI-generated content. This tool is widely used by
            educators, content creators, researchers, and professionals to
            ensure authenticity, detect plagiarism, and maintain content
            integrity. With quick and accurate results, AI detectors help users
            make informed decisions about the origin and credibility of written
            material.
          </p>
        </div>
      </div>
    </div>
  );
}

export default SectionAIDetect;
